//@flow
import {GetAwsRegionsQuery, AwsRegion} from '../../autogenerated/ZoomBridge';
export default class GetAwsRegions{

  run():Promise<Array<AwsRegion>>{
    const query = new GetAwsRegionsQuery();
    query.message="ignore";
    return query.run();
  }
}